import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { type FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useRequestsContext } from "../../contexts/RequestsContext";
import { INK_BLACK, STATUS } from "../../theme/tokens";
import { PostToAgencyControl } from "../staffing/PostToAgencyControl";

type Props = {
	requestId: string;
};
export const PostedGap: FC<Props> = ({ requestId }) => {
	const navigate = useNavigate();
	const { staffRequests } = useRequestsContext();
	const request = staffRequests.find((r) => r.id === requestId);

	const handlePostedGapClick = useCallback(() => {
		const searchParams = new URLSearchParams(window.location.search);
		searchParams.set("requestId", requestId);
		navigate(`${window.location.pathname}?${searchParams.toString()}`, { replace: true });
	}, [navigate, requestId]);
	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
			<Box
				onClick={handlePostedGapClick}
				sx={{
					p: 0.5,
					pl: 0,
					display: "flex",
					justifyContent: "start",
					color: STATUS.SUCCESS.main,
					fontWeight: 600,
					fontSize: "12px",
					cursor: "pointer",
					":hover": {
						background: alpha(INK_BLACK, 0.1),
						transition: "background-color 0.25s ease",
						borderRadius: 1,
					},
				}}
			>
				Posted
			</Box>
			{request && <PostToAgencyControl request={request} variant="iconToggle" />}
		</Box>
	);
};
